import { Autocomplete, TextField, Tooltip } from '@mui/material';
import React from 'react';
import { useThunk } from './useThunk';

/**
 * OrderAutocomplete Component
 *
 * A reusable autocomplete component for searching orders by ID.
 * It encapsulates the fetching logic and handles debounce internally via useThunk hook.
 */
const OrderAutocomplete = ({
    value,
    onChange,
    onSelect,
    organisationId,
    setError,
    label = 'Order #',
    placeholder,
    required = false,
    ...rest
}) => {
    const {
        options,
        loading,
        inputValue,
        handleInputChange,
    } = useThunk({ value, organisationId, setError });

    const handleInternalChange = (event, newValue) => {
        if (newValue && typeof newValue === 'object') {
            onChange(String(newValue.id));
            if (onSelect) onSelect(newValue);
        } else {
            onChange(newValue || '');
            if (onSelect) onSelect(newValue);
        }
    };

    return (
        <Autocomplete
            {...rest}
            freeSolo
            options={options}
            loading={loading}
            inputValue={inputValue}
            noOptionsText={inputValue.length < 4 ? 'Type at least 4 characters' : 'No orders found'}
            getOptionLabel={(option) => {
                if (typeof option === 'string') return option;
                return option.id ? String(option.id) : '';
            }}
            onInputChange={handleInputChange}
            onChange={handleInternalChange}
            renderInput={(params) => (
              <Tooltip
                title={!organisationId ? 'Please select an organisation first' : ''}
                placement='top'
                arrow
              >
                  <TextField
                    {...params}
                    label={label}
                    required={required}
                    variant='outlined'
                    placeholder={!organisationId ? 'Select Organisation first' : (placeholder || 'Search Order #')}
                  />
              </Tooltip>
            )}
        />
    );
};

export default OrderAutocomplete;
